import { t } from '@/i18n';
import { z } from 'zod';
import { MatchScheduleFormat } from '@/model';

const I18N_PREFIX = 'pages.application_championship_matches.components.match_generate_modal';

export const modalFormSchema = z.object({
  championship_uuid: z.string().optional(),
  season_uuid: z.string().optional(),
  stage_uuid: z.string().min(1, t(`${I18N_PREFIX}.schema.required_stage`)),
  schedule_format: z.nativeEnum(MatchScheduleFormat, {
    errorMap: () => ({ message: t(`${I18N_PREFIX}.schema.required_format`) }),
  }),
  start_date: z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/, t(`${I18N_PREFIX}.schema.required_date`)),
  interval_days: z.preprocess(
    value => {
      if (value === '' || value === undefined || value === null) return NaN;
      return Number(value);
    },
    z
      .number({ invalid_type_error: t(`${I18N_PREFIX}.schema.invalid_interval`) })
      .int(t(`${I18N_PREFIX}.schema.invalid_interval`))
      .min(1, t(`${I18N_PREFIX}.schema.invalid_interval`)),
  ),
  replace_existing: z.boolean().optional(),
});

export type ModalFormData = z.infer<typeof modalFormSchema>;
